import { useT } from "../lib/i18n.jsx";

/** QR glyph: three finder squares and a few modules. Inline, no icon set. */
export function QrGlyph({ size = 22 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true" fill="currentColor">
      <path d="M3 3h7v7H3V3zm2 2v3h3V5H5zM14 3h7v7h-7V3zm2 2v3h3V5h-3zM3 14h7v7H3v-7zm2 2v3h3v-3H5z" />
      <path d="M14 14h3v3h-3zM18 14h3v3h-3zM14 18h3v3h-3zM18 18h3v3h-3zM16.5 16.5h2v2h-2z" />
    </svg>
  );
}

/** "Open this map on your phone" (item 0324), pinned bottom-right.
 *
 *  Always on screen above phone width. Nothing in the viewer hides it: the menu
 *  card lives top-left (item 0314), the directions panel is capped to stop
 *  above it (RouteBanner, side by side) or sits in the left column (stacked),
 *  and the zoom column ends 96px above the bottom edge. It sits 40px up, not
 *  in the corner, because MapLibre's attribution button owns the bottom-right
 *  24px and the basemap's licence needs it reachable.
 *
 *  - Wide (side by side, or no route): a labelled pill. On a 55" totem an
 *    unlabelled 44px glyph is the speck item 0314 was about.
 *  - Stacked band with a route (641-819px): the language picker owns the bottom
 *    row up to 68px from the right, so the button shrinks to the right gutter's
 *    44px -- the same column as the zoom buttons and floor pills.
 *  - Phone: rendered inside MapControls' left column instead (see there); the
 *    bottom sheet owns the bottom of a phone, as it does for every other
 *    control (item 0093).
 */
export default function QrButton({ stacked = false, inline = false, onClick }) {
  const { t } = useT();
  if (stacked) {
    return (
      <button
        data-qr-button
        onClick={onClick}
        aria-label={t("qr_button")}
        title={t("qr_button")}
        className="absolute bottom-10 right-3 z-20 flex h-11 w-11 items-center justify-center
                   rounded-lg bg-slate-800 text-white shadow-md active:bg-slate-700"
      >
        <QrGlyph />
      </button>
    );
  }
  return (
    <button
      data-qr-button
      onClick={onClick}
      className={
        // `inline`: inside the bottom-right dock next to the assistant button
        // (item 0325), which does the positioning; same place either way.
        (inline ? "" : "absolute bottom-10 right-3 z-20 ") +
        "flex h-12 items-center gap-2.5 rounded-xl bg-slate-800 px-4 text-sm font-semibold " +
        "text-white shadow-lg active:bg-slate-700"
      }
    >
      <QrGlyph size={24} />
      <span className="whitespace-nowrap">{t("qr_button")}</span>
    </button>
  );
}
